import { MealPlanAgent } from "@corpuscomplete/core/nutrition/meal-plan-agent";
import {
  MealPlanningMemberContextAgent,
  MealPlanningSessionPlannerAgent,
} from "@corpuscomplete/core/nutrition/meal-planning-agent";
import { createClientAgentRegistry } from "../agent-definition/registry";

export function createAgentRegistry() {
  const clientRegistry = createClientAgentRegistry();
  clientRegistry.registerAgent(MealPlanAgent.definition);
  clientRegistry.registerAgent(MealPlanningMemberContextAgent.definition);
  clientRegistry.registerAgent(MealPlanningSessionPlannerAgent.definition);
  return clientRegistry;
}
